import {
    AggregatedUserExternalRewardsPnlResponse,
    BsMetaUtil,
    getMintsFromExternalRewards,
    useOraclePrices
} from "@bridgesplit/abf-react";
import { Column, StatColumn, StatProps, Text } from "@bridgesplit/ui";
import { TokenAmountWithUsd } from "app/components/common";

import { useVaultContext } from "../VaultContext";

const DEFAULT_STAT_ROWS = 2;

const SKELETON_STATS: StatProps[] = Array(DEFAULT_STAT_ROWS).fill({
    value: null,
    caption: null,
    hide: false
});

export function VaultExternalRewardsHeader() {
    const { userExternalRewardsPosition } = useVaultContext();

    const mints = getMintsFromExternalRewards(userExternalRewardsPosition);

    const { getUsdPrice } = useOraclePrices(mints);

    const stats = getVaultExternalRewardsStats({
        externalRewards: userExternalRewardsPosition,
        getUsdPrice
    });

    return (
        <Column spacing={2}>
            <Text variant="h4">Rewards</Text>
            <StatColumn stats={stats ?? SKELETON_STATS} loading={!userExternalRewardsPosition} />
        </Column>
    );
}

function getVaultExternalRewardsStats({
    externalRewards,
    getUsdPrice
}: {
    externalRewards: AggregatedUserExternalRewardsPnlResponse | null | undefined;
    getUsdPrice: (mint: string) => number | undefined;
}): StatProps[] | undefined {
    if (!externalRewards) return undefined;

    const stats: StatProps[] = [];

    // Iterate through each vault's rewards
    Object.values(externalRewards).forEach((vaultRewards) => {
        Object.values(vaultRewards).forEach((reward) => {
            const usdPrice = getUsdPrice(reward.rewardMint);
            const symbol = BsMetaUtil.getSymbol(reward.rewardMetadata);

            const stat: StatProps = {
                value: (
                    <TokenAmountWithUsd
                        amount={reward.claimedRewards}
                        token={reward.rewardMetadata}
                        condensedOnMobile
                        amountUsd={reward.claimedRewards * (usdPrice ?? 0)}
                    />
                ),
                caption: `Total ${symbol} claimed`
            };

            if (stat) {
                stats.push(stat);
            }
        });
    });

    return stats;
}
